module.exports = __webpack_public_path__ + "img/SN.010dc497.svg";